import React from 'react'
import { Link } from 'react-router-dom'
// import { Tooltip } from 'antd'
// import VolTips from 'components/VolTips'
import useStore from 'store'
import { addRlog } from 'utils/util'
import s from './index.module.less'
import ac from './images/ac.png'
import ta from './images/ta.png'
import un from './images/un.png'
import right from './images/right.png'

const AiMap = [
  {
    src: ac,
    sub: '院校优先填报',
    des: '大数据+AI智能推荐合适您的院校',
    inter: '查看院校推荐',
    link: { pathname: `/collegesVolunteer`, search: `?type=1` }
  },
  {
    src: ta,
    sub: '专业优先填报',
    des: '大数据+AI智能推荐合适您的专业',
    inter: '查看专业推荐',
    link: { pathname: `/collegesVolunteer`, search: `?type=2` }
  },
  {
    src: un,
    sub: '目标院校概率',
    des: '测算目标院校录取概率',
    inter: '概率测算',
    link: '/probabilityVolunteer'
  }
]

const AfterVolunteer: React.FC<{}> = () => {
  const { state } = useStore()

  const toPage = (type: string, source: string) => {
    addRlog('page_enter', {
      page_name: type,
      source
    })
  }

  return (
    <section className={s.AfterVolunteer}>
      <ul className={s.volMsg}>
        <li>
          <p className={s.title}>高考省份</p>
          <p className={s.name}>{state.volunteerData?.gkProvince}</p>
        </li>
        <li>
          <p className={s.title}>高考科目</p>
          <p className={s.name}>{state.volunteerData?.projectTypeStr}</p>
        </li>
        <li>
          <p className={s.title}>高考成绩</p>
          <p className={s.name}>{state.volunteerData?.gkTotalScore}分</p>
        </li>
        {/* <li>
          <p className={`${s.title} ${s.rankTips}`}>
            全省排名
            <Tooltip title={VolTips} color="#fff" trigger="hover" overlayStyle={{ maxWidth: 350 }}>
              <p className={s.quesIcon} />
            </Tooltip>
          </p>

          <p className={s.name}>{state.volunteerData?.rank}名</p>
        </li> */}
      </ul>
      <Link to="/collegesVolunteer?type=1">
        <button
          type="button"
          className={`${s.sure}`}
          onClick={() => toPage('院校优先填报', '首页-智能推荐按钮')}
        >
          智能推荐
        </button>
      </Link>
      <ul className={s.intro}>
        {AiMap.map((item) => (
          <li key={item.sub}>
            <img src={item.src} alt="img" />
            <p className={s.sub}>{item.sub}</p>
            <p className={s.dec}>{item.des}</p>
            <Link to={item.link}>
              <p className={s.inter}>
                <button type="button" onClick={() => toPage(item.inter, `首页-${item.inter}按钮`)}>
                  {item.inter} <img src={right} alt="img" />
                </button>
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default AfterVolunteer
